import { message } from 'antd';


export function showMessage(type, msg, des) {
  
  // {string} msg 提示内容
  // {number} duration 单位秒
  message[type](msg, 1);
}